<div [autoResize]=true [initOpts]="initOptions" [options]="chartOptions" class="demo-chart" echarts></div>
